import { render, staticRenderFns } from "./CreateCommunity.vue?vue&type=template&id=544f774a&scoped=true&"
import script from "./CreateCommunity.vue?vue&type=script&lang=ts&"
export * from "./CreateCommunity.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCommunity.vue?vue&type=style&index=0&id=544f774a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544f774a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VSelect,VTextField,VTextarea})
